import { GetContactsForCompanyBlock } from "./GetContactsForCompanyBlock";
import { AnalyseCompanyDataBlock } from "../../ui/AnalyseCompanyDataBlock";
import { StartGenerateAccountPlan } from "../../accounts/StartGenerateAccountPlan";
import { CampaignDetailsResponse } from "../../../types/apiTypes";
import { useAppSelector } from "../../../hooks";

export const CompanyActionBlock = ({
  account_id,
  campaign_id,
  account,
  hasContacts,
  canAnalyzeAll,
  is_analyzed,
  successCallBack,
  status,
  progress,
  isDisabled,
}: {
  account: CampaignDetailsResponse;
  hasContacts: boolean;
  canAnalyzeAll: boolean;
  is_analyzed: boolean;
  successCallBack: () => void;
  status: string;
  account_id: string;
  campaign_id: string;
  progress: number;
  isDisabled: boolean;
}) => {
  const { isEditor } = useAppSelector((state) => state.company.userRoles);

  if (!hasContacts && isEditor)
    return (
      <GetContactsForCompanyBlock account_id={account_id} account={account} />
    );

  if (canAnalyzeAll && !is_analyzed && isEditor)
    return (
      <AnalyseCompanyDataBlock
        title={"You Haven’t Analysed This Company Yet"}
        text={[
          "Start analysis to get more details about Buying committee members",
        ]}
        campaign_id={campaign_id}
        account_id={account_id}
        isDisabled={isDisabled}
        status={status}
        progress={progress}
        successCallBack={successCallBack}
      />
    );

  if (canAnalyzeAll && isEditor)
    return (
      <AnalyseCompanyDataBlock
        title={"Your Analysis May Be Outdated"}
        text={[
          "The account information has been updated. Run re-analysis to refresh Buying Committee insights.",
        ]}
        campaign_id={campaign_id}
        account_id={account_id}
        isDisabled={isDisabled}
        status={status}
        progress={progress}
        successCallBack={successCallBack}
      />
    );

  if (is_analyzed && (account.has_account_plan || isEditor))
    return (
      <StartGenerateAccountPlan
        account_id={account_id}
        account={account}
        campaign_id={campaign_id}
      />
    );

  return null;
};
